<template>
    <div class="funItem">
        <div class="itemTitle">{{ title }}</div>
        <div class="itemImg">
            <img v-if="type == 1" :class="full_screen == 1 ? 'full_screen' : ''" :src="url" alt="" />
            <video :src="url" v-else autoplay muted loop webkit-playsinline playsinline x5-video-player-type="h5-page"
                x5-playsinline="true" preload="auto"
                :poster="url + '?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
        </div>
        <div class="bottomText">{{ desc }}</div>
    </div>
</template>

<script>
export default {
    props: {
        desc: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
        full_screen: {
            type: [String,Number],
            default: '2',
        },
        type: {
            type: [String, Number],
            default: 1,
        },
    },
    data() {
        return {

        }
    },
    created() {

    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.funItem {
    margin-top: 0px;
    margin-bottom: 116px;

    .itemTitle {
        font-weight: 500;
        font-size: 40px;
        color: #000000;
        width: 1200px;
        margin: auto;
    }

    .itemImg {
        width: 100%;
        margin-top: 36px;

        img {
            width: 1200px;
            height: 700px;
            object-fit: cover;
            margin: auto;
            display: block;
        }

        video {
            width: 1200px;
            height: 700px;
            object-fit: cover;
            margin: auto;
            display: block;
        }

        .full_screen {
            width: 100%;
        }
    }

    .bottomText {
        width: 1200px;
        margin: auto;
        font-size: 21px;
        color: #000000;
        margin-top: 40px;
    }
}

@media screen and (max-width:1200px) {
    .funItem {
        margin-top: 20px;

        .itemTitle {
            font-weight: 500;
            font-size: 18px;
            color: #000000;
            width: 100%;
            margin: auto;
            box-sizing: border-box;
            padding: 0 15px;
            word-break: break-word;
        }

        .itemImg {
            width: 100%;
            margin-top: 20px;
            box-sizing: border-box;
            padding: 0 15px;

            img {
                width: 100%;
                max-width: 100%;
                height: auto;
                object-fit: cover;
                margin: auto;
                display: block;
            }

            video {
                width: 100%;
                max-width: 100%;
                height: auto;
                object-fit: cover;
                margin: auto;
                display: block;
            }

            .full_screen {
                width: 100%;
            }
        }

        .bottomText {
            width: 100%;
            margin: auto;
            font-size: 14px;
            color: #000000;
            margin-top: 20px;
            box-sizing: border-box;
            padding: 0 15px;
            word-break: break-word;
        }
    }
}
</style>